import { useContext } from 'react'

import { AirbyteContext } from './context'

export function useAirbyteContext() {
  const context = useContext(AirbyteContext)

  if (!context) {
    throw new Error('useAirbyteContext must be used within an AirbyteProvider')
  }

  return context
}
